import { useSelector } from "react-redux";
import Loader from "../../../../components/loader";
import AdminLayout from "../../../../layouts/AdminLayout";
import Wellness from "../../../../components/pages/comman/nuvio-wellness";

const CreateNuterra = () => {
  const { isLoading } = useSelector((state) => state.admin.auth);
  if (isLoading) {
    return <Loader />;
  }
  return (
    <AdminLayout>
      <Wellness contentEditable={true} />
    </AdminLayout>
  );
};

export default CreateNuterra;
